import { AppThunk } from 'redux/store'
import { WEBSOCKET_WORD_FLOW_ACTIVATED } from 'constants.js'
import { getShow } from 'redux/slices/liveShow'
import { getShowChannel } from 'redux/slices/interaction'
import moment from 'moment'
import { postWordFlowMessage } from 'api/api'
import { createTimer } from 'redux/slices/timers/thunks'
import { Timer, getTimer } from 'redux/slices/timers'
import {
    wordAdded,
    hasReachedMessageLimit,
    increaseMessagesSent,
    WORD_FLOW_DURATION_IN_SECONDS,
    calculateProgress,
    activate,
    getEndDate,
    deactivate,
    closeWarning,
    getTimeLeft,
} from '.'

export const submitWord = (word: string, userId: string): AppThunk => async (dispatch, getState) => {
    const showId = getShow(getState())?._id

    dispatch(wordAdded({ word, userId }))

    if (!hasReachedMessageLimit(getState())) {
        dispatch(increaseMessagesSent())
        await postWordFlowMessage({
            message: word,
            timestamp: new Date().toISOString(),
            showId,
        })
    }
}

export const start = (): AppThunk => async (dispatch, getState) => {
    const wsChannel = getShowChannel(getState())

    const endDate = moment()
        .add(WORD_FLOW_DURATION_IN_SECONDS, 'seconds')
        .toISOString()

    const timeLeft = getTimeLeft(endDate)

    dispatch(
        createTimer(Timer.WORDFLOW_TIME_LEFT, timeLeft, () => {
            dispatch(finish())
        }),
    )

    dispatch(calculateProgress())

    dispatch(activate(endDate))

    wsChannel?.trigger(WEBSOCKET_WORD_FLOW_ACTIVATED, {
        endDate: getEndDate(getState()),
    })
}

export const resume = (): AppThunk => async (dispatch, getState) => {
    const endDate = getEndDate(getState())
    if (!endDate) return

    if (!getTimer(getState(), Timer.WORDFLOW_TIME_LEFT)) {
        const timeLeft = getTimeLeft(endDate)

        dispatch(
            createTimer(Timer.WORDFLOW_TIME_LEFT, timeLeft, () => {
                dispatch(finish())
            }),
        )
    }
}

export const startCalculatingProgress = (): AppThunk => async (dispatch, getState) => {
    const endDate = getEndDate(getState())
    if (!endDate) return

    dispatch(calculateProgress())
}

export const finish = (): AppThunk => async dispatch => {
    dispatch(deactivate())
}

export const closeWarningMsg = (): AppThunk => async dispatch => {
    dispatch(closeWarning())
}
